<template>
    <div style="margin: auto; width: 1000px">
        <p style="text-align: center; font-size: 22px">条码设置</p>
        <el-form>
            <div style="width: 1000px; margin: auto" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <tr>
                                <td ref="tdlbl_生成规则" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    生成规则
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="4">
                                    <el-checkbox-group v-model="field">
                                        <el-checkbox v-for="(option, index) in checkedList" :key="index" :disabled="index === 0" :label="option.value" />
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_条码规则" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    条码规则
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="4">
                                    <span v-for="(option, index) in field" :key="index">{{ option === field[field.length - 1] ? option : option + '+' }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_打印尺寸" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    打印尺寸
                                </td>
                                <td class="el-table__cell tdcont tdw83" colspan="4">
                                    <el-select v-model="printSize" style="width: 100%" placeholder="请选择打印尺寸">
                                        <el-option v-for="item in chooseList" :key="item.value" :label="item.text" :value="item.value" />
                                    </el-select>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_条码示例" class="el-table__cell tdlbl tdw17" colspan="1">条码示例</td>
                                <td class="el-table__cell tdcont tdw83" colspan="5">
                                    <div style="display: flex; justify-content: space-around; align-items: center; margin: 20px 0px">
                                        <div style="width: 300px; height: 300px; border: 1px solid #ebeef5; position: relative">
                                            <div style="text-align: center">
                                                <p style="display: block; font-size: var(--portalFontSize12); line-height: 0px; padding-bottom: 6px">{{ loginUser.orgName }}</p>
                                                <div>
                                                    <img style="width: 230px; height: 75px" src="../imgs/print_img.png" alt="" />
                                                </div>
                                                <div style="display: grid; grid-template: auto auto auto auto / auto auto auto auto; width: 300px; padding-left: 35px; padding-right: 35px">
                                                    <img style="width: 100px; height: 100px" src="../imgs/print_img2.png" alt="" />
                                                    <div style="font-size: var(--portalFontSize12); padding-left: 8px">
                                                        <p v-for="(item, index) in arrList" :key="index" style="width: 145px; dispaly: inline-block; flex: 1; line-height: 5px; font-size: var(--portalFontSize12); text-align: left">
                                                            <span>{{ item.value }}</span>
                                                            <span style="padding-left: 5px; text-align: right; float: right">{{ item.text }}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="text-align: center; position: absolute; left: 0; right: 0; bottom: 0">
                                                <el-radio v-model="type" label="1">模板一</el-radio>
                                            </div>
                                        </div>
                                        <div style="width: 300px; height: 300px; border: 1px solid #ebeef5; position: relative">
                                            <div style="text-align: center">
                                                <p style="display: block; font-size: var(--portalFontSize12); line-height: 0px; padding-bottom: 6px">{{ loginUser.orgName }}</p>
                                                <div style="display: grid; grid-template: auto auto auto auto / auto auto auto auto; width: 300px; padding-left: 35px; padding-right: 35px">
                                                    <div style="font-size: var(--portalFontSize12); padding-right: 8px">
                                                        <p v-for="(item, index) in arrList" :key="index" style="width: 145px; dispaly: inline-block; flex: 1; line-height: 5px; font-size: var(--portalFontSize12); text-align: left">
                                                            <span>{{ item.value }}</span>
                                                            <span style="padding-left: 5px; text-align: right; float: right">{{ item.text }}</span>
                                                        </p>
                                                    </div>
                                                    <img style="width: 100px; height: 100px" src="../imgs/print_img2.png" alt="" />
                                                </div>
                                                <div style="margin-top: 17px">
                                                    <img style="width: 230px; height: 75px" src="../imgs/print_img.png" alt="" />
                                                </div>
                                            </div>
                                            <div style="text-align: center; position: absolute; left: 0; right: 0; bottom: 0">
                                                <el-radio v-model="type" label="2">模板二</el-radio>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <template>
                <div style="width: 100%; text-align: center; margin-top: 20px">
                    <el-button type="primary" icon="el-icon-check" @click="submitFn">保 存</el-button>
                </div>
            </template>
        </el-form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    components: {},
    props: {},
    data() {
        return {
            checkedList: [],
            chooseList: [],
            field: [],
            numberLength: '',
            printSize: '',
            type: '1',
            arrList: [],
            option1: '1',
            option2: '',
            id: '',
            list: []
            // newfield: []
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {
        field(arr) {
            const arrList = []
            arr.forEach((item, index) => {
                this.checkedList.forEach((list) => {
                    if (item === list.value) {
                        arrList.push(list)
                    }
                })
            })
            this.arrList = arrList
        }
    },
    created() {
        this.$bus.emit('showNavSearch', false) // 取消右上搜索按钮
        this.getInit()
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true) // 还原右上搜索按钮
    },
    mounted() {},
    methods: {
        getInit() {
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/zcgl/codeSetting/getCodeSetting`,
                method: 'GET'
            }).then((res) => {
                if (res.code === 'success') {
                    this.checkedList = res.body.vo.passenger.fieldOptions
                    this.checkedList.forEach((item, index) => {
                        if (item.value === '资产金额') {
                            this.checkedList.splice(index, 1)
                        }
                    })
                    this.chooseList = res.body.vo.passenger.printSizeOptions
                    this.id = res.body.vo.id
                    this.field = res.body.vo.field.split(',')
                    // this.newfield = this.field.join('+')
                    this.type = res.body.vo.type + ''
                    this.numberLength = res.body.vo.numberLength
                    this.chooseList.map((item) => {
                        if (+item.value === res.body.vo.printSize) {
                            this.printSize = item.value
                        }
                    })
                    res.body.vo.passenger.fieldOptions.forEach((item, index) => {
                        this.field.forEach((innerItem) => {
                            if (innerItem === item.value) {
                                this.list.push(item)
                            }
                        })
                    })
                }
                console.log(this.checkedList)
            })
        },
        // 提交
        submitFn() {
            if (this.field.length < 3) {
                this.$message.error('生成规则至少选择三个')
                return
            }
            const params = {
                field: this.field.join(','),
                printSize: this.printSize,
                orgCode: this.loginUser.orgCode,
                orgName: this.loginUser.orgName,
                id: this.id,
                type: this.type
            }
            if (!params.field) {
                return this.$alert('条码规则是必须的！', '操作提示', { type: 'warning' })
            }
            if (!params.printSize) {
                return this.$alert('模板选择是必须的！', '操作提示', { type: 'warning' })
            }
            if (!params.type) {
                return this.$alert('打印尺寸是必须的！', '操作提示', { type: 'warning' })
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/zcgl/codeSetting/saveCodeSetting`,
                method: 'POST',
                data: params
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                } else {
                    this.$message.error(res.message)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.aaa {
    font-size: 22px;
}
</style>
